export default "/images/vendor/flag-icon-css/flags/4x3/kh.svg?7b33804c913e2285c5387a26b6a95a08";